import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { IModalStore, ModalType } from '../../stores/ModalStore';

import ProductCurrentBalanceModal from '../currentbalances/ProductCurrentBalanceModal';
import InvoicePaymentModal from './paymentmodal/InvoicePaymentModal';
import PayAllPaymentModal from './paymentmodal/PayAllPaymentModal';
import PosPaymentModal from './paymentmodal/PosPaymentModal';
import PrepaymentModal from './paymentmodal/PrepaymentModal';
import InvoiceSettingsModal from './settings/InvoiceSettingsModal';
import InvoiceDetailsModalWrapper from './details/InvoiceDetailsModalWrapper';
import InvoiceLineUsagesModal from './details/InvoiceLineUsagesModal';

interface IAppModalProviderProps {
  modalStore?: IModalStore;
}

@inject('modalStore')
@observer
export default class AppModalProvider extends React.Component<IAppModalProviderProps> {
  public render(): JSX.Element {
    const modal = this.props.modalStore.activeModal;

    if (modal === ModalType.InvoicePaymentModal) {
      return <InvoicePaymentModal />;
    }
    if (modal === ModalType.InvoiceDetailsModal) {
      return <InvoiceDetailsModalWrapper />;
    }
    if (modal === ModalType.InvoiceLineUsagesModal) {
      return <InvoiceLineUsagesModal />;
    }
    if (modal === ModalType.PayAllInvoicesPaymentModal) {
      return <PayAllPaymentModal />;
    }
    if (modal === ModalType.PrepaymentPaymentModal) {
      return <PrepaymentModal />;
    }
    if (modal === ModalType.InvoiceSettingsModal) {
      return <InvoiceSettingsModal />;
    }
    if (modal === ModalType.PosPaymentModal) {
      return <PosPaymentModal />;
    }

    if (modal === ModalType.ProductCurrentBalanceModal) {
      return <ProductCurrentBalanceModal />;
    }

    return null;
  }
}
